import React, { useEffect, useRef } from "react";

import IconClose from '../../../img/icon-close.svg';

import { ButtonFeedback } from "./ButtonFeedback";

import { allFeedbacks, CustomerFeedbackProps } from "../interface";
import { Title, Container, Content } from "./styles";

export const CustomerFeedback: React.FC<CustomerFeedbackProps> = (props) => {

  const {
    setCustomerResponseFeedback,
    customerResponseFeedback,
    sendCustomerDataCollection,
    dataStoreTotem
  } = props;

  const timerFeedback = useRef<any>();

  useEffect(() => {
    customerDoesNotRespondToFeedbackAfterTimeoutSendData();
  }, []);

  useEffect(() => {
    if (customerResponseFeedback) {
      clearTimeout(timerFeedback.current);
      sendCustomerDataCollection();
    }
  }, [customerResponseFeedback]);

  const handleFeedback = (feedback: string) => {
    setCustomerResponseFeedback(feedback);
  };

  const customerDoesNotRespondToFeedbackAfterTimeoutSendData = () => {
    timerFeedback.current = setTimeout(() => {
      if (customerResponseFeedback === "")
        sendCustomerDataCollection(true);
    }, dataStoreTotem?.questionTimeout);
    return () => clearTimeout(timerFeedback.current);
  };

  return (
    <Container>
      <img src={IconClose} onClick={() => handleFeedback("Fechou a pergunta")} />
      <Title>
        Na sua opinião, o que podemos melhorar?
      </Title>

      <Content>
        {allFeedbacks.map((item: string) => (
          <ButtonFeedback
            key={item}
            textBtn={item}
            handleFeedback={handleFeedback}
          />
        ))}
      </Content>
    </Container>
  );
};
